import {AFFILIATE_SERVICE_URL} from "../constants/api";
import { CALL_API } from '../login/api.middleware';
import * as type from '../constants/ActionTypes';


export function fetchItems(clientId) {

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/items`,
      types: [
        type.ITEM_LIST_REQUEST,
        type.ITEM_LIST_SUCCESS,
        type.ITEM_LIST_FAILURE
      ],
      authenticated: true,
      params: {
        clientId: clientId,
      },
    }
  };
}